<template>
  <div>
    <v-overlay :value="loading" absolute>
        <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>
    <div v-if="!loading">
      <app-form
        v-bind:parentObject="{
          data: this.formData,
          pageTitle: this.pageTitle,
          pageTitleValue: this.pageTitleValue,
          errMsg: this.errMsg,
          isEdit: this.editMode,
        }"
        v-on:input="formData= $event"
        v-on:save="saveHandler"
        v-on:cancel="cancelHandler"
        v-on:error="errorHandler"
      />

      <div v-if="isErr">
        <app-error
          v-bind:parentError="{
            data: this.errMsg,
            isErr: this.isErr,
          }"
          v-on:closeError="isErr = $event"
        />
      </div>

      <div v-if="isConfirm">
        <app-confirm
          v-bind:parentObject="{
            pageTitleValue: this.pageTitleValue,
            isConfirm: this.isConfirm,
          }"
          v-on:confirm="deleteHandler($event)"
          v-on:cancelConfirm="isConfirm = !isConfirm"
        />
      </div>
    </div>
  </div>
</template>

<script>
import FormSetupForm from "../../../components/performance/formsetup/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";
import ConfirmDialog from "../../../components/common/ConfirmDialog";

export default {
  components: {
    "app-form": FormSetupForm,
    "app-error": ErrorDialog,
    "app-confirm": ConfirmDialog,
  },

  data() {
    return {
      id: this.$route.params.id,
      pageTitle: this.$t('Setupformsetup.editformsetup'),
      pageTitleValue: "",
      formData: {
        id: null,
        formcode: null,
        formname: null,
        disable: false,
        formtype: null,
        maxscore: null,
        weightingunit: null,
        pmrankmapsetid: null,
        pmgridranksetid: null,
        stamp: 0,
        userid: this.$store.getters.userId,
      },

      // rankmapSetDetailsList: [],

      errMsg: "",
      isErr: false,
      loading: true,
      editMode: true,
      isConfirm: false,
    };
  },

  methods: {

    errorHandler($event) {
    this.isErr = $event.isErr;
    this.errMsg = $event.errMsg;
    },

    async loadReviewForm() {
      const vm = this;

      try {
        const res = await this.$store.dispatch('get', {url: "/reviewform/" + vm.id});
        vm.formData = res.data.rec[0];
        vm.pageTitleValue = res.data.rec[0].formcode;
      } catch (err) {
        vm.isErr = !vm.isErr;
        vm.errMsg = err;
      }
    },

    saveHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
        return false;
      }

      this.$store.dispatch('put', {url: "/reviewform/" + vm.id, payload: this.formData})
        .then((res) => {
          if (res.data.error) {
            vm.isErr = !vm.isErr;
            vm.errMsg = res.data.error;
          } else {
            this.$router.push({ name: "formsetuplist" });
          }
        })
        .catch((err) => {
          vm.isErr = !vm.isErr;
          vm.errMsg = err;
        });
    },
  },

  async mounted() {
    Promise.all([await this.loadReviewForm()])
      .then(() => {
        this.loading = false;
      })
      .catch((err) => {
        this.isErr = true;
        this.errMsg = err;
      });
  },
};
</script>